import React from "react";
import {
  InformationCircleIcon,
  ExclamationCircleIcon,
  LockClosedIcon,
  TruckIcon,
  CreditCardIcon,
  DocumentTextIcon,
} from "@heroicons/react/20/solid";

const TermAndConditions = () => {
  return (
    <div className="container mx-auto p-6 max-w-7xl text-gray-800">
      <h1 className="text-3xl font-bold text-center mb-6">
        Uslovi korišćenja NutriTrans
      </h1>

      <nav className="mb-6 p-4 bg-gray-100 rounded-lg shadow">
        <ul className="space-y-2">
          <li>
            <a href="#uvod" className="text-blue-600 hover:underline">
              1. Uvod i Prihvaćanje Uslova
            </a>
          </li>
          <li>
            <a href="#koriscenje" className="text-blue-600 hover:underline">
              2. Korišćenje Aplikacije
            </a>
          </li>
          <li>
            <a href="#placanje" className="text-blue-600 hover:underline">
              3. Plaćanje i Pretplata
            </a>
          </li>
          <li>
            <a href="#autorska-prava" className="text-blue-600 hover:underline">
              4. Autorska prava i Intelektualna Svojina
            </a>
          </li>
          <li>
            <a href="#odgovornost" className="text-blue-600 hover:underline">
              5. Ograničenje odgovornosti
            </a>
          </li>
          <li>
            <a href="#privatnost" className="text-blue-600 hover:underline">
              6. Privatnost i Zaštita podataka
            </a>
          </li>
          <li>
            <a href="#prekid-usluge" className="text-blue-600 hover:underline">
              7. Prekid Usluge i Otkazivanje
            </a>
          </li>
          <li>
            <a
              href="#resavanje-sporova"
              className="text-blue-600 hover:underline"
            >
              8. Rešavanje Sporova
            </a>
          </li>
          <li>
            <a href="#izmene" className="text-blue-600 hover:underline">
              9. Izmene i Ažuriranje Uslova
            </a>
          </li>
          <li>
            <a href="#kontakt" className="text-blue-600 hover:underline">
              10. Kontakt Informacije
            </a>
          </li>
        </ul>
      </nav>

      <div className="bg-white shadow-lg rounded-lg p-6 border border-gray-200 overflow-y-auto h-screen">
        <h2 id="uvod" className="text-md font-semibold text-gray-900 mb-4">
          1. Uvod i Prihvaćanje Uslova
        </h2>
        <p className="mb-4">
          Dobrodošli u NutriTrans aplikaciju. Ovim Uslovima korišćenja (dalje:
          "Uslovi") uređuju se prava i obaveze korisnika prilikom korišćenja
          aplikacije NutriTrans i usluga koje ona pruža. Molimo vas da pažljivo
          pročitate ove Uslove pre nego što pristupite ili počnete da koristite
          aplikaciju.
        </p>

        <h2
          id="uvodPodnaslov"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Naziv kompanije i vlasništvo aplikacije
        </h2>

        <p className="mb-4">
          NutriTrans aplikacija je vlasništvo kompanije PR Veljko Milicevic
          Nutritivna Transformacija, sa sedištem na adresi Cipikova 7,
          registrovane u Agenciji za privredne registre Republike Srbije pod
          brojem Matični broj kompanije 63754145 i PIB-om 108860232 (dalje:
          "Kompanija"). Svi sadržaji, funkcionalnosti, i softverski elementi
          unutar aplikacije zaštićeni su zakonima Republike Srbije o autorskim
          pravima, intelektualnoj svojini i industrijskom vlasništvu.
        </p>

        <h2
          id="uvodPodnaslov1"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Prihvatanje uslova
        </h2>

        <p className="mb-4">
          Pristupanjem, registrovanjem ili korišćenjem aplikacije NutriTrans, vi
          kao korisnik (dalje: "Korisnik") potvrđujete da ste pročitali,
          razumeli i da se slažete sa svim odredbama ovih Uslova. U slučaju da
          se ne slažete sa bilo kojim delom ovih Uslova, molimo vas da
          prestanete sa korišćenjem aplikacije
        </p>

        <p className="mb-4">Korisnik prihvata Uslove putem sledećih radnji:</p>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>Kreiranjem naloga unutar aplikacije.</li>
          <li>
            Označavanjem polja "Slažem se sa Uslovima korišćenja" prilikom
            registracije ili korišćenja aplikacije.
          </li>
          <li>
            Nastavljanjem sa korišćenjem aplikacije nakon obaveštenja o
            promenama Uslova.
          </li>
        </ol>

        <p className="mb-4">
          U skladu sa Zakonom o elektronskoj trgovini Republike Srbije
          ("Službeni glasnik RS", br. 41/2009, 95/2013 i 52/2019), elektronska
          prihvatanja ovih Uslova imaju punu pravnu snagu i obavezujuće dejstvo.
        </p>

        <h2
          id="uvodPodnaslov2"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Izmene uslova
        </h2>

        <p className="mb-4">
          Kompanija zadržava pravo da u bilo kom trenutku i prema sopstvenom
          nahođenju izmeni ili dopuni ove Uslove, u skladu sa važećim zakonima
          Republike Srbije. O svim značajnim promenama Uslova Kompanija će
          blagovremeno obavestiti Korisnike putem jednog od sledećih kanala:
        </p>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>
            Slanjem email obaveštenja na adresu koju je Korisnik naveo prilikom
            registracije.
          </li>
          <li>
            Prikazivanjem obaveštenja unutar aplikacije prilikom sledećeg
            pristupa Korisnika.
          </li>
          <li>Obaveštavanjem putem službenog sajta NutriTrans aplikacije.</li>
        </ol>

        <p className="mb-4">
          Izmene će stupiti na snagu u roku od 7 dana od dana obaveštenja, osim
          ukoliko zakoni ne nalažu drugačiji rok. Ukoliko Korisnik nastavi da
          koristi aplikaciju nakon stupanja izmena na snagu, smatraće se da je
          prihvatio nove Uslove. Ukoliko se Korisnik ne slaže sa izmenama, ima
          pravo da prestane da koristi aplikaciju i da deaktivira svoj nalog.
        </p>

        <h2
          id="uvodPodnaslov3"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Kontakt
        </h2>

        <p className="mb-4">
          Za sve dodatne informacije ili objašnjenja u vezi sa ovim Uslovima,
          Korisnici mogu kontaktirati Kompaniju putem email adrese{" "}
          <a
            href="mailto:office@nutritrans.com"
            className="text-blue-300 hover:text-blue-500"
          >
            office@nutritrans.com
          </a>
          .
        </p>

        <h2
          id="koriscenje"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          2. Korišćenje Aplikacije
        </h2>
        <p className="mb-4">
          Ova sekcija reguliše uslove i način korišćenja NutriTrans aplikacije,
          pristup aplikaciji i registraciju korisnika, kao i ograničenja u vezi
          sa upotrebom aplikacije.
        </p>

        <h2
          id="koriscenjePodnaslov"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Pristup i registracija
        </h2>

        <p className="mb-4">
          Da biste koristili NutriTrans aplikaciju, potrebno je da kreirate
          korisnički nalog. Kreiranje naloga je dostupno svim licima koja
          ispunjavaju uslove korišćenja navedene u ovom dokumentu.
        </p>

        <p className="mb-4">
          Korisnik je dužan da prilikom registracije unese tačne i potpune
          podatke, uključujući:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>Ime i prezime.</li>
          <li>Važeću email adresu.</li>
          <li>Lozinku (koju korisnik mora čuvati u tajnosti).</li>
          <li>
            Dodatne informacije kao što su godine, pol, težina, visina i drugi
            podaci potrebni za personalizovane usluge aplikacije.
          </li>
        </ul>

        <p className="mb-4">
          Registracijom i kreiranjem korisničkog naloga, Korisnik dobija
          neekskluzivno, neprenosivo pravo pristupa i korišćenja NutriTrans
          aplikacije u skladu sa ovim Uslovima korišćenja i važećim zakonima
          Republike Srbije.
        </p>

        <p className="mb-4">
          Kompanija PR Nutritivna Transformacija zadržava pravo da odbije
          registraciju ili deaktivira nalog u slučaju da se otkrije da je
          korisnik dao netačne podatke ili prekršio ove Uslove korišćenja
        </p>

        <p className="mb-4">
          Korisnik je odgovoran za čuvanje poverljivosti svog korisničkog
          naloga, uključujući lozinku. Svi postupci preduzeti pod korisničkim
          nalogom smatraju se kao postupci koje je preduzeo sam korisnik.
        </p>

        <h2
          id="koriscenjePodnaslov1"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Ograničenja upotrebe
        </h2>

        <p className="mb-4">
          Korisnicima je dozvoljeno da koriste NutriTrans aplikaciju isključivo
          u skladu sa njenom namenom, a zabranjena je sledeća upotreba:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Deljenje naloga:</strong> Korisnicima nije dozvoljeno
            deljenje korisničkog naloga sa trećim licima ili dozvoljavanje
            drugim licima da koriste nalog.
          </li>
          <li>
            <strong>Neovlašćena upotreba:</strong> Zabranjeno je koristiti
            aplikaciju na način koji krši zakone Republike Srbije, uključujući,
            ali ne ograničavajući se na, neovlašćeno prikupljanje ili
            distribuciju podataka, zloupotrebu funkcionalnosti, ometanje rada
            aplikacije, ili pokušaj neovlašćenog pristupa sistemu.
          </li>
          <li>
            <strong>Lažno predstavljanje:</strong> Korisnici ne smeju lažno
            predstavljati sebe ili druge osobe, niti koristiti tuđe podatke za
            pristup aplikaciji.
          </li>
          <li>
            <strong>Distribucija sadržaja:</strong> Svi sadržaji u aplikaciji
            vlasništvo su kompanije{" "}
            <strong>PR Nutritivna Transformacija</strong> i nije dozvoljeno
            preuzimanje, distribucija ili komercijalna upotreba tih sadržaja bez
            izričite dozvole.
          </li>
        </ul>

        <p className="mb-4">
          Kompanija zadržava pravo da preduzme odgovarajuće mere protiv
          korisnika koji prekrše ove odredbe, uključujući, ali ne ograničavajući
          se na, suspenziju naloga, zabranu daljeg korišćenja aplikacije i
          pravne postupke u skladu sa važećim zakonima.
        </p>

        <h2
          id="koriscenjePodnaslov2"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Uzrast korisnika
        </h2>

        <p className="mb-4">
          Korišćenje NutriTrans aplikacije dozvoljeno je isključivo punoletnim
          licima, starijim od 18 godina, u skladu sa Zakonom o zaštiti potrošača
          ("Službeni glasnik RS", br. 62/2014 i 6/2016). Korisnici mlađi od 18
          godina ne mogu koristiti ovu aplikaciju, niti kreirati nalog.
        </p>

        <p className="mb-4">
          Ukoliko Korisnik zloupotrebi ili falsifikuje podatke o godinama kako
          bi pristupio aplikaciji, Kompanija zadržava pravo da deaktivira nalog
          i preduzme odgovarajuće mere.
        </p>

        <h2 id="placanje" className="text-md font-semibold text-gray-900 mb-4">
          3. Plaćanje i Pretplata
        </h2>
        <p className="mb-4">
          Korišćenje NutriTrans aplikacije je zasnovano na pretplatničkom
          modelu. U ovoj sekciji su navedeni uslovi i pravila koja se odnose na
          cenu pretplate, način plaćanja, pravila o povraćaju novca i
          automatskoj obnovi pretplate.
        </p>

        <p className="mb-4">
          Sva plaćanja biće izvršena u lokalnoj valuti Republike Srbije – dinar
          (RSD).Za informativni prikaz cena u drugim valutama koristi se srednji
          kurs Narodne Banke Srbije. Iznos za koji će biti zadužena Vaša platna
          kartica biće izražen u Vašoj lokalnoj valuti kroz konverziju u istu po
          kursu koji koriste kartičarske organizacije, a koji nama u trenutku
          transakcije ne može biti poznat. Kao rezultat ove konverzije postoji
          mogućnost neznatne razlike od originalne cene navedene na našem sajtu
        </p>

        <p className="mb-4">
          <i>
            PR Veljko Milicevic Nutritivna Transformacija nije obveznik PDV-a
          </i>
        </p>

        <h2
          id="placanjePodnaslov"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Model pretplate
        </h2>

        <p className="mb-4">
          <strong>NutriTrans aplikacija – Planovi pretplate i cene</strong>
        </p>

        <p className="mb-4">
          NutriTrans aplikacija je dostupna kroz više nivoa pretplate,
          prilagođenih različitim potrebama korisnika.
        </p>

        <div className="container mx-auto p-1">
          <div className="bg-white shadow-lg rounded-lg p-4 mb-3">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              1. Besplatni paket – 0 RSD
            </h2>
            <p className="text-gray-600 mb-4">
              Pruža osnovne funkcionalnosti za korisnike koji žele da isprobaju
              aplikaciju pre prelaska na plaćene pakete.
            </p>
            <ul className="list-disc pl-5 text-gray-700">
              <li>✅ Razne kalkulacije (BMI, BMR, TDEE, procene...)</li>
              <li>✅ Kompletni izveštaji (za 3 i 7 dana)</li>
              <li>✅ Mogućnost kreiranja 1 jelovnik</li>
            </ul>
          </div>

          <div className="bg-white shadow-lg rounded-lg p-4 mb-3">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              2. Osnovni paket (mesečni) – 3.000 RSD / mesec
            </h2>
            <p className="text-gray-600 mb-4">
              Pogodan za korisnike koji žele personalizovane planove ishrane uz
              osnovne funkcije aplikacije.
            </p>
            <ul className="list-disc pl-5 text-gray-700">
              <li>✅ Razne kalkulacije (BMI, BMR, TDEE, procene...)</li>
              <li>✅ Kompletni izveštaji (za 3 i 7 dana)</li>
              <li>✅ Mogućnost kreiranja do 8 jelovnika mesečno</li>
              <li>✅ Planovi mršavljenja (umereno i agresivno)</li>
            </ul>
          </div>

          <div className="bg-white shadow-lg rounded-lg p-4 mb-3">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              3. Osnovni paket (godišnji) – 25.000 RSD / godina
            </h2>
            <p className="text-gray-600 mb-4">
              📌 Ušteda u odnosu na mesečnu pretplatu!
            </p>
            <ul className="list-disc pl-5 text-gray-700">
              <li>✅ Sve pogodnosti iz Osnovnog paketa (mesečni)</li>
              <li>✅ Plaćanje unapred za celu godinu donosi popust!</li>
              <li>✅ Konsultacije sa nutricionistom (30 minuta mesečno)</li>
              <li>✅ Garancija povrata novca</li>
            </ul>
          </div>

          <div className="bg-white shadow-lg rounded-lg p-4 mb-3">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              4. Napredni paket (mesečni) – 12.000 RSD / mesec
            </h2>
            <p className="text-gray-600 mb-4">
              Pogodan za korisnike koji žele dodatnu podršku nutricioniste i
              napredne funkcije aplikacije.
            </p>
            <ul className="list-disc pl-5 text-gray-700">
              <li>✅ Razne kalkulacije (BMI, BMR, TDEE, procene...)</li>
              <li>✅ Kompletni izveštaji (za 3 i 7 dana)</li>
              <li>✅ Mogućnost kreiranja do 20 jelovnika mesečno</li>
              <li>✅ Planovi mršavljenja (umereno i agresivno)</li>
              <li>✅ Konsultacije sa nutricionistom (30 minuta mesečno)</li>
              <li>✅ Garancija povrata novca</li>
              <li>
                ✅ Tvoje smanjenje (dodatne prilagođene preporuke za
                optimizaciju plana ishrane)
              </li>
            </ul>
          </div>

          <div className="bg-white shadow-lg rounded-lg p-4 mb-3">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              5. Napredni paket (godišnji) – 90.000 RSD / godina
            </h2>
            <p className="text-gray-600 mb-4">
              📌 Najbolja vrednost za korisnike koji žele dugoročan plan!
            </p>
            <ul className="list-disc pl-5 text-gray-700">
              <li>✅ Sve pogodnosti iz Naprednog paketa (mesečni)</li>
              <li>
                ✅ Plaćanje unapred za celu godinu donosi značajan popust!
              </li>
            </ul>
          </div>
        </div>

        <p className="mb-4">
          <strong>Napomena:</strong>
        </p>

        <p className="mb-4">
          Kompanija PR Nutritivna Transformacija zadržava pravo da izmeni cenu
          pretplate, u skladu sa važećim zakonima. Korisnici će biti
          blagovremeno obavešteni o svakoj promeni, najmanje{" "}
          <strong>30 dana pre nego što izmene stupe na snagu.</strong> Ako
          korisnik ne prihvati novu cenu, ima pravo da otkaže pretplatu pre nego
          što nova cena stupi na snagu.
        </p>

        <h2
          id="placanjePodnaslov1"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Način plaćanja
        </h2>

        <p className="mb-4">Pretplata se plaća putem sledećih metoda:</p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Kreditne ili debitne kartice</strong> (Visa, MasterCard,
            itd.).
          </li>
          <li>
            <strong>Elektronske platforme za plaćanje</strong>
          </li>
          <li>
            <strong>Bankovni transferi</strong>(po dogovoru)
          </li>
        </ul>

        <p className="mb-4">
          Sve transakcije se vrše putem bezbednih servisa za plaćanje, u skladu
          sa standardima zaštite podataka o ličnosti i podacima o plaćanju.
          Kompanija ne čuva podatke o platnim karticama korisnika.
        </p>

        <h2
          id="placanjePodnaslov2"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Pravila o povraćaju novca
        </h2>

        <p className="mb-4">
          NutriTrans aplikacija omogućava povraćaj novca samo u sledećim
          slučajevima:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            Ako korisnik nije u mogućnosti da koristi aplikaciju zbog tehničkih
            problema izazvanih greškom aplikacije.
          </li>
          <li>
            Ako se korisnik obrati kompaniji u roku od{" "}
            <strong>14 dana od dana plaćanja</strong> sa zahtevom za povraćaj, u
            skladu sa Zakonom o zaštiti potrošača Republike Srbije ("Službeni
            glasnik RS", br. 62/2014 i 6/2016).
          </li>
        </ul>

        <p className="mb-4">
          Zahtev za povraćaj novca može se podneti putem email adrese{" "}
          <a
            href="mailto:office@nutritrans.com"
            className="text-blue-300 hover:text-blue-500"
          >
            office@nutritrans.com
          </a>
          .. Nakon odobrenja zahteva, povraćaj novca će biti izvršen na istu
          platnu metodu kojom je izvršena uplata, u roku od 14 dana od dana
          prijema zahteva. Kompanija zadržava pravo da odbije povraćaj novca
          ukoliko utvrdi da je zahtev neopravdan ili da korisnik nije ispunio
          navedene uslove.
        </p>

        <h2
          id="placanjePodnaslov3"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Automatska obnova pretplate
        </h2>

        <p className="mb-4">
          Pretplata na NutriTrans aplikaciju funkcioniše na principu{" "}
          <strong>automatske obnove</strong>, što znači da će se pretplata
          automatski produžiti na kraju svakog mesečnog perioda, a vaša platna
          metoda će biti naplaćena za naredni mesec korišćenja, osim ako
          korisnik ne otkaže pretplatu pre datuma obnove
        </p>

        <p className="mb-4">
          Korisnik može otkazati pretplatu u bilo kom trenutku putem postavki
          naloga unutar aplikacije ili slanjem email zahteva na{" "}
          <a
            href="mailto:office@nutritrans.com"
            className="text-blue-300 hover:text-blue-500"
          >
            office@nutritrans.com
          </a>
          . Otkazivanje pretplate stupa na snagu na kraju trenutnog mesečnog
          ciklusa i neće biti naplate za naredni mesec.
        </p>

        <p className="mb-4">
          Korisnici će biti obavešteni putem emaila{" "}
          <strong>najmanje 7 dana pre</strong> datuma automatske obnove o
          nadolazećoj obnovi pretplate, kako bi imali vremena da, ukoliko žele,
          otkažu pretplatu pre nego što im platna metoda bude naplaćena.
        </p>

        <p className="mb-4">
          Kompanija nije odgovorna za naknade koje mogu nastati kao posledica
          neblagovremenog otkazivanja pretplate od strane korisnika.
        </p>

        <h2
          id="autorska-prava"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          4. Autorska prava i Intelektualna Svojina
        </h2>

        <p className="mb-4">
          Ova sekcija se odnosi na prava vlasništva nad sadržajem i
          intelektualnu svojinu u vezi sa NutriTrans aplikacijom. Korišćenje
          aplikacije podrazumeva da korisnik prihvata sledeće uslove u vezi sa
          intelektualnim pravima.
        </p>

        <h2
          id="autorkaPravaPodnaslov"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Vlasništvo nad sadržajem
        </h2>

        <p className="mb-4">
          Svi tekstovi, grafički elementi, slike, dizajn, logo, softver,
          algoritmi, baze podataka, kao i svi ostali materijali i sadržaji koji
          se nalaze unutar NutriTrans aplikacije (dalje: "Sadržaj") vlasništvo
          su kompanije <strong>PR Nutritivna Transformacija</strong>,i zaštićeni
          su zakonima Republike Srbije o autorskom pravu i intelektualnoj
          svojini.
        </p>

        <p className="mb-4">
          Korišćenjem NutriTrans aplikacije, Korisnici ne stiču bilo kakva prava
          vlasništva ili licencu nad Sadržajem aplikacije, osim prava koja su
          izričito navedena ovim Uslovima korišćenja.
        </p>

        <p className="mb-4">
          Svi elementi aplikacije, uključujući softver, algoritme i baze
          podataka, zaštićeni su u skladu sa Zakonom o autorskim i srodnim
          pravima Republike Srbije, kao i međunarodnim konvencijama koje
          regulišu ovu oblast.
        </p>

        <h2
          id="autorkaPravaPodnaslov1"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Korišćenje sadržaja
        </h2>

        <p className="mb-4">
          Korisnicima je dozvoljeno korišćenje NutriTrans aplikacije isključivo
          za lične potrebe, u skladu sa njenom namenom. Sadržaj aplikacije ne
          sme se kopirati, preuzimati, menjati, javno prikazivati,
          redistribuirati ili koristiti u komercijalne svrhe bez prethodne
          pisane saglasnosti kompanije{" "}
          <strong>PR Nutritivna Transformacija</strong>. Konkretno, korisnici
          nisu ovlašćeni da:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            Kopiraju, modifikuju, preuzimaju ili distribuiraju bilo koji deo
            Sadržaja aplikacije bez prethodnog odobrenja.
          </li>
          <li>
            Koriste algoritme, baze podataka ili softverske komponente u druge
            svrhe osim za ličnu upotrebu unutar aplikacije.
          </li>
          <li>
            Kreiraju "mirror" kopije ili na bilo koji način preslikavaju delove
            aplikacije na druge servere ili uređaje.
          </li>
          <li>
            Objavljuju, prodaju, licenciraju, ili koriste sadržaj aplikacije u
            komercijalne svrhe bez odobrenja.
          </li>
        </ul>

        <p className="mb-4">
          Svi sadržaji koje korisnici postave unutar aplikacije (npr. komentari,
          podaci, unosi u vezi sa zdravljem) ostaju u vlasništvu korisnika, ali
          korisnik daje kompaniji <strong>PR Nutritivna Transformacija</strong>{" "}
          neekskluzivnu, prenosivu, podlicenciranu licencu za korišćenje tih
          podataka za potrebe unapređenja usluga aplikacije, u skladu sa
          Politikom privatnosti i Zakonom o zaštiti podataka o ličnosti
          ("Službeni glasnik RS", br. 87/2018).
        </p>

        <h2
          id="autorkaPravaPodnaslov2"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Povreda autorskih prava
        </h2>

        <p className="mb-4">
          Ukoliko korisnik prekrši odredbe ovog Ugovora o korišćenju u vezi sa
          autorskim pravima i intelektualnom svojinom, Kompanija zadržava pravo
          da preduzme odgovarajuće mere, uključujući:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>Ograničenje ili suspenziju pristupa aplikaciji.</li>
          <li>
            Pravne radnje u skladu sa zakonima Republike Srbije, uključujući
            pokretanje parničnog postupka radi naknade štete i druge pravne
            mere.
          </li>
        </ul>

        <p className="mb-4">
          Kompanija <string>PR Nutritivna Transformacija</string> zadržava pravo
          da u slučaju povrede autorskih prava zahteva naknadu štete, troškove
          sudskih postupaka, kao i druge troškove koji mogu nastati kao
          posledica povrede.
        </p>

        <h2
          id="autorkaPravaPodnaslov3"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Prijava povrede autorskih prava
        </h2>

        <p className="mb-4">
          Ukoliko smatrate da su vaša autorska prava povređena korišćenjem
          NutriTrans aplikacije, molimo vas da nas kontaktirate putem email
          adrese{" "}
          <a
            href="mailto:office@nutritrans.com"
            className="text-blue-300 hover:text-blue-500"
          >
            office@nutritrans.com
          </a>{" "}
          i dostavite sve relevantne informacije o navodnoj povredi,
          uključujući:
        </p>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>
            Detaljan opis zaštićenog dela za koje tvrdite da je povređeno.
          </li>
          <li>Dokaze o vašem vlasništvu nad autorskim pravima.</li>
          <li>Kontakt informacije (email i telefon).</li>
        </ol>

        <p className="mb-4">
          Kompanija će ispitati sve prijave povrede i, ukoliko utvrdi da je
          povreda osnovana, preduzeti odgovarajuće mere.
        </p>

        <h2
          id="odgovornost"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          5. Ograničenje odgovornosti
        </h2>

        <p className="mb-4">
          Korišćenjem NutriTrans aplikacije, korisnici prihvataju da aplikacija
          pruža personalizovane preporuke u vezi sa ishranom i fizičkim
          zdravljem, ali da te preporuke ne zamenjuju medicinski savet niti su
          garantovani određeni rezultati.
        </p>

        <h2
          id="odgovornostPodnaslov"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Zdravstvene preporuke
        </h2>

        <p className="mb-4">
          NutriTrans aplikacija koristi podatke koje korisnici sami unose u
          cilju pružanja personalizovanih planova ishrane, fizičke aktivnosti i
          preporuka za poboljšanje zdravlja. Ove preporuke su namenjene
          isključivo za informativne i edukativne svrhe i nisu zamena za
          profesionalni medicinski savet, dijagnozu ili lečenje.
        </p>

        <p className="mb-4">
          Korisnici bi trebalo da konsultuju lekara ili licenciranog
          zdravstvenog profesionalca pre nego što započnu bilo kakvu promenu
          ishrane, fizičke aktivnosti ili drugih zdravstvenih navika. NutriTrans
          aplikacija ne preuzima odgovornost za bilo kakve posledice korišćenja
          preporuka koje su dobijene putem aplikacije.
        </p>

        <p className="mb-4">
          Korisnici se izričito slažu da NutriTrans aplikacija ne garantuje
          postizanje specifičnih zdravstvenih rezultata, uključujući gubitak
          težine, poboljšanje fizičkog stanja, ili lečenje zdravstvenih stanja.
        </p>

        <h2
          id="odgovornostPodnaslov1"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Tačnost podataka
        </h2>

        <p className="mb-4">
          NutriTrans aplikacija pruža personalizovane planove ishrane i
          preporuke isključivo na osnovu podataka koje korisnici unose u
          aplikaciju. Korisnik snosi isključivu odgovornost za tačnost,
          potpunost i verodostojnost svih podataka koje unosi, uključujući, ali
          ne ograničavajući se na, podatke o telesnoj težini, visini,
          zdravstvenom stanju, navikama u ishrani i fizičkoj aktivnosti.
        </p>

        <p className="mb-4">
          Kompanija <strong>PR Nutritivna Transformacija</strong> ne preuzima
          odgovornost za tačnost ili pouzdanost preporuka ukoliko su one
          bazirane na netačnim ili nepotpunim informacijama koje je korisnik
          uneo u aplikaciju.
        </p>

        <p className="mb-4">
          Aplikacija ne može garantovati tačnost preporuka ili planova ishrane
          ukoliko korisnik nije uneo relevantne podatke ili ih je uneo netačno.
          Korisnici preuzimaju punu odgovornost za posledice bilo kakvog
          netačnog unosa podataka.
        </p>

        <h2
          id="odgovornostPodnaslov2"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Izuzimanje odgovornosti
        </h2>

        <p className="mb-4">
          NutriTrans aplikacija, kao ni kompanija{" "}
          <strong>PR Nutritivna Transformacija</strong>, nije odgovorna za bilo
          kakve direktne, indirektne, slučajne, posebne ili posledične štete
          koje mogu proizaći iz korišćenja aplikacije ili oslanjanja na
          preporuke koje aplikacija daje, uključujući, ali ne ograničavajući se
          na, povrede, zdravstvene probleme ili druge komplikacije koje mogu
          nastati kao posledica promena ishrane ili fizičkih aktivnosti.
        </p>

        <p className="mb-4">
          Korišćenje NutriTrans aplikacije vrši se na vlastitu odgovornost
          korisnika. NutriTrans i kompanija{" "}
          <strong>PR Nutritivna Transformacija</strong> ne daju nikakve
          garancije da će preporuke, planovi ishrane ili rezultati biti
          efikasni, bezbedni ili pogodni za korisnika, niti preuzimaju
          odgovornost za ishode primene tih preporuka.
        </p>

        <p className="mb-4">
          Kompanija <strong>PR Nutritivna Transformacija</strong> nije odgovorna
          za bilo kakve zdravstvene probleme, alergijske reakcije, ili
          komplikacije koje mogu nastati kao rezultat korišćenja aplikacije ili
          preporuka dobijenih putem aplikacije. Preporuke koje se pružaju u
          aplikaciji nisu zamena za profesionalni medicinski tretman ili savet.
        </p>

        <p className="mb-4">
          Korisnik je u obavezi da samostalno proceni da li su preporuke koje
          dobija putem aplikacije pogodne za njegovu situaciju, u skladu sa
          savetima koje je prethodno dobio od lekara ili drugog licenciranog
          zdravstvenog stručnjaka.
        </p>

        <p className="mb-4">
          U meri dozvoljenoj zakonom Republike Srbije, kompanija{" "}
          <strong>PR Nutritivna Transformacija</strong> isključuje bilo kakvu
          odgovornost za bilo koje troškove, gubitke ili štete nastale usled
          upotrebe aplikacije.
        </p>

        <h2
          id="privatnost"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          6. Privatnost i Zaštita podataka
        </h2>
        <p className="mb-4">
          NutriTrans aplikacija posvećuje veliku pažnju zaštiti privatnosti
          korisnika i prikuplja, koristi i štiti podatke u skladu sa važećim
          zakonima Republike Srbije, uključujući Zakon o zaštiti podataka o
          ličnosti. U ovoj sekciji detaljno su objašnjeni način prikupljanja,
          korišćenja, deljenja i brisanja podataka korisnika.
        </p>

        <p className="mb-4">
          <strong>Prikupljanje i korišćenje podataka</strong>
        </p>

        <p className="mb-4">
          NutriTrans aplikacija prikuplja sledeće vrste podataka od korisnika:
        </p>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>
            <strong>Lični podaci:</strong> uključuju ime, prezime, email adresu,
            datum rođenja, pol, kao i druge informacije koje korisnik unese
            prilikom registracije i korišćenja aplikacije.
          </li>
          <li>
            <strong>Podaci o zdravlju:</strong> informacije o težini, visini,
            merama struka i vrata, podatke o fizičkoj aktivnosti, navikama u
            ishrani, i druge podatke koje korisnik dobrovoljno unosi radi
            dobijanja personalizovanih planova ishrane i preporuka.
          </li>
          <li>
            <strong>Tehnički podaci:</strong> IP adresa, podaci o uređaju,
            operativnom sistemu i verziji aplikacije, kao i kolačići koji
            omogućavaju praćenje upotrebe aplikacije i unapređenje korisničkog
            iskustva.
          </li>
        </ol>

        <p className="mb-4">Prikupljeni podaci se koriste u sledeće svrhe:</p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Personalizacija usluga:</strong> Kako bi aplikacija mogla da
            kreira personalizovane planove ishrane i fizičkih aktivnosti na
            osnovu unetih podataka.
          </li>
          <li>
            <strong>Analitika i poboljšanje usluga:</strong> Za prikupljanje
            podataka o načinu korišćenja aplikacije radi analize i unapređenja
            usluga.
          </li>
          <li>
            <strong>Komunikacija sa korisnicima:</strong> Za slanje važnih
            obaveštenja, informacija o promenama u aplikaciji, podršci
            korisnicima i marketingu, uz prethodnu saglasnost korisnika.
          </li>
        </ul>

        <p className="mb-4">
          Korisnici mogu biti sigurni da su svi prikupljeni podaci obrađeni u
          skladu sa zakonom i da se ne koriste u druge svrhe osim onih koje su
          izričito navedene u ovim Uslovima korišćenja i u{" "}
          <strong>Politici privatnosti</strong>.
        </p>

        <h2
          id="odgovornostPodnaslov3"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Deljenje podataka
        </h2>

        <p className="mb-4">
          NutriTrans aplikacija se obavezuje da neće deliti podatke korisnika sa
          trećim stranama, osim u sledećim slučajevima:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Pravna obaveza:</strong> U slučaju kada je Kompanija dužna
            da deli podatke u skladu sa zakonom ili pravosnažnim nalogom
            nadležnog organa
          </li>
          <li>
            <strong>Tehnička podrška:</strong> Sa trećim stranama koje pružaju
            tehničke usluge ili usluge obrade podataka za aplikaciju (npr.
            hosting, analitika, obrade podataka). U takvim slučajevima, treće
            strane su u obavezi da čuvaju poverljivost podataka i koriste ih
            isključivo u svrhe za koje su angažovane.
          </li>
          <li>
            <strong>Marketing</strong> Korisnički podaci mogu biti korišćeni za
            slanje marketinških poruka samo uz prethodnu saglasnost korisnika.
            Korisnici imaju pravo da u svakom trenutku povuku svoju saglasnost
            za marketinške aktivnosti
          </li>
        </ul>

        <p className="mb-4">
          NutriTrans aplikacija ne prodaje, ne iznajmljuje i ne trguje podacima
          korisnika trećim stranama u komercijalne svrhe
        </p>

        <h2
          id="odgovornostPodnaslov4"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Pravo na brisanje podataka
        </h2>

        <p className="mb-4">
          Korisnici imaju pravo da u bilo kom trenutku zatraže brisanje svojih
          podataka u skladu sa Zakonom o zaštiti podataka o ličnosti. Da bi
          korisnik iskoristio ovo pravo, potrebno je da se obrati kompaniji
          putem emaila{" "}
          <a
            href="mailto:office@nutritrans.com"
            className="text-blue-300 hover:text-blue-500"
          >
            office@nutritrans.com
          </a>{" "}
          sa zahtevom za brisanje podataka.
        </p>
        <p className="mb-4">
          Po prijemu zahteva, NutriTrans će u roku od 30 dana obrisati sve
          podatke korisnika iz sistema, osim podataka koji su neophodni za
          ispunjenje zakonskih obaveza ili podataka koji se moraju čuvati u
          skladu sa zakonskim obavezama (npr. podaci o plaćanjima).
        </p>
        <p className="mb-4">
          Korisnici mogu takođe zatražiti pristup svojim podacima, njihovu
          izmenu ili ograničenje obrade u skladu sa važećim zakonima.
        </p>

        <h2
          id="odgovornostPodnaslov5"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Bezbednost podataka
        </h2>
        <p className="mb-4">
          Kompanija <string>PR Nutritivna Transformacija</string> koristi
          odgovarajuće tehničke i organizacione mere za zaštitu podataka
          korisnika od neovlašćenog pristupa, izmene, otkrivanja ili
          uništavanja. Ovo uključuje enkripciju podataka, bezbedne servere i
          procedure za kontrolu pristupa. Uprkos preduzetim merama, nijedan
          sistem nije apsolutno siguran, te korisnici koriste aplikaciju na
          sopstveni rizik.
        </p>
        <p className="mb-4">
          U slučaju bilo kakve povrede podataka, Kompanija će u skladu sa
          zakonom obavestiti nadležne organe i pogođene korisnike u najkraćem
          mogućem roku.
        </p>

        <h2
          id="odgovornostPodnaslov6"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Kontakt i dodatne informacije
        </h2>

        <p className="mb-4">
          Za sva pitanja u vezi sa zaštitom privatnosti i podataka korisnici se
          mogu obratiti Kompaniji putem email adrese{" "}
          <a
            href="mailto:office@nutritrans.com"
            className="text-blue-300 hover:text-blue-500"
          >
            office@nutritrans.com
          </a>{" "}
          ili telefonski na +381 62 24 25 01.
        </p>

        <h2
          id="prekid-usluge"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          7. Prekid Usluge i Otkazivanje
        </h2>
        <p className="mb-4">
          Ova sekcija reguliše uslove pod kojima Kompanija može suspendovati ili
          ukinuti pristup korisnicima aplikacije NutriTrans, kao i način na koji
          korisnici mogu otkazati svoj nalog i kako se postupa sa njihovim
          podacima nakon otkazivanja.
        </p>

        <h2
          id="prekidPodnaslov"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Pravila o suspenziji
        </h2>

        <p className="mb-4">
          Kompanija NutriTrans zadržava pravo da privremeno suspenduje ili
          trajno ukine pristup korisniku aplikacije u sledećim slučajevima:
        </p>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>
            <strong>Kršenje Uslova korišćenja:</strong> Ako korisnik prekrši
            bilo koji deo ovih Uslova korišćenja, uključujući, ali ne
            ograničavajući se na, zloupotrebu sadržaja aplikacije, neovlašćeno
            korišćenje aplikacije, davanje netačnih podataka ili kršenje pravila
            o zaštiti privatnosti.
          </li>
          <li>
            <strong>Neovlašćena upotreba: </strong>Ako se utvrdi da korisnik
            koristi aplikaciju za nelegalne aktivnosti ili bilo kakve radnje
            koje su u suprotnosti sa zakonima Republike Srbije, uključujući
            pokušaj neovlašćenog pristupa sistemima ili ometanje rada
            aplikacije.
          </li>
          <li>
            <strong>Neplaćanje pretplate:</strong>U slučaju da korisnik ne
            izvrši uplatu pretplate u skladu sa definisanim rokovima, kompanija
            zadržava pravo da privremeno ograniči pristup funkcionalnostima
            aplikacije sve dok uplata ne bude izvršena.
          </li>
          <li>
            <strong>Zahtev nadležnog organa:</strong>U slučaju da postoji pravni
            nalog ili zahtev nadležnog organa Republike Srbije za suspendovanje
            korisnika zbog pravnih ili bezbednosnih razloga.
          </li>
        </ol>

        <p className="mb-4">
          Korisnici će, ukoliko je moguće, biti obavešteni putem emaila o
          razlozima suspenzije ili ukidanja naloga, kao i o potencijalnim
          koracima koje mogu preduzeti kako bi rešili problem i povratili
          pristup.
        </p>

        <h2
          id="prekidPodnaslov1"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Otkazivanje naloga
        </h2>

        <p className="mb-4">
          Korisnici mogu u svakom trenutku otkazati svoj nalog putem sledećih
          opcija:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Putem aplikacije:</strong>Korisnici mogu otkazati svoj nalog
            tako što će pristupiti postavkama naloga unutar aplikacije i
            odabrati opciju "Otkazivanje naloga."
          </li>
          <li>
            <strong>Putem emaila:</strong> Korisnici mogu zatražiti otkazivanje
            naloga slanjem zahteva na email adresu [email adresa kompanije], uz
            pružanje potrebnih podataka za verifikaciju identiteta (npr. email
            adresa registrovana u aplikaciji).
          </li>
        </ul>

        <p className="mb-4">
          Otkazivanje naloga stupa na snagu odmah po prijemu i potvrdi zahteva,
          a korisnik će dobiti email potvrdu o uspešnom otkazivanju naloga.
          Nakon otkazivanja, korisnik više neće imati pristup aplikaciji i svim
          podacima povezanih sa korisničkim nalogom.
        </p>

        <h2
          id="prekidPodnaslov2"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Podaci nakon otkazivanja naloga
        </h2>

        <p className="mb-4">
          Po otkazivanju naloga, Kompanija se obavezuje da:
        </p>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>
            <strong>Obriše ili anonimizuje sve lične podatke korisnika</strong>{" "}
            u roku od <strong>30 dana</strong>, osim u slučajevima kada se
            određeni podaci moraju čuvati u skladu sa važećim zakonima Republike
            Srbije (npr. podaci o plaćanju, fakture).
          </li>
          <li>
            Korisnik neće imati pravo na povraćaj novca za neiskorišćene periode
            pretplate nakon otkazivanja naloga, osim ako nije drugačije
            definisano ovim Uslovima ili Zakonom o zaštiti potrošača.
          </li>
        </ol>

        <p className="mb-4">
          Ako korisnik želi da povrati nalog nakon otkazivanja, moraće da kreira
          novi nalog, jer svi podaci povezani sa prethodnim nalogom neće biti
          dostupni.
        </p>

        <h2
          id="prekidPodnaslov3"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Postupak žalbe
        </h2>

        <p className="mb-4">
          Ukoliko korisnik smatra da je nepravedno suspendovan ili da je
          otkazivanje naloga bilo neosnovano, može uputiti žalbu Kompaniji putem
          email adrese{" "}
          <a
            href="mailto:office@nutritrans.com"
            className="text-blue-300 hover:text-blue-500"
          >
            office@nutritrans.com
          </a>{" "}
          . Kompanija će razmotriti žalbu i dostaviti odgovor korisniku u roku
          od <strong>30 dana</strong>.
        </p>

        <h2
          id="resavanje-sporova"
          className="text-md font-semibold text-gray-900 mb-4"
        >
          8. Rešavanje Sporova
        </h2>
        <p className="mb-4">
          Ova sekcija definiše pravila i postupak rešavanja eventualnih sporova
          koji mogu nastati između korisnika i kompanije u vezi sa korišćenjem
          NutriTrans aplikacije.
        </p>

        <h2
          id="sporoviPodnaslov"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Primena zakona
        </h2>

        <p className="mb-4">
          Na ove Uslove korišćenja, kao i na sve sporove ili zahteve koji
          proisteknu iz korišćenja NutriTrans aplikacije ili su u vezi sa njom,
          primenjuju se zakoni Republike Srbije. Ovi Uslovi su sastavljeni u
          skladu sa zakonima Republike Srbije, uključujući, ali ne
          ograničavajući se na:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            Zakon o zaštiti potrošača ("Službeni glasnik RS", br. 62/2014 i
            6/2016).
          </li>
          <li>
            Zakon o obligacionim odnosima ("Službeni glasnik SFRJ", br. 29/1978,
            39/1985, 45/1989 i 57/1989, "Službeni glasnik RS", br. 31/1993).
          </li>
          <li>
            Zakon o zaštiti podataka o ličnosti ("Službeni glasnik RS", br.
            87/2018).
          </li>
        </ul>

        <p className="mb-4">
          Svi sporovi koji nastanu u vezi sa tumačenjem, primenom ili
          sprovođenjem ovih Uslova biće rešavani u skladu sa zakonodavstvom
          Republike Srbije.
        </p>

        <h2
          id="sporoviPodnaslov1"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Arbitraža i rešavanje sporova
        </h2>

        <p className="mb-4">
          U slučaju bilo kakvog spora, nesporazuma ili zahteva koji proisteknu
          iz korišćenja NutriTrans aplikacije ili su u vezi sa njom, Korisnik i
          Kompanija će pokušati da spor reše mirnim putem kroz pregovore. Ako
          strane ne mogu da postignu sporazum mirnim putem, sledeći mehanizmi
          rešavanja sporova biće primenjeni:
        </p>

        <ol className="list-decimal pl-6 space-y-2 mb-4">
          <li>
            <strong>Arbitraža:</strong>Strane se obavezuju da će sve sporove
            koji proisteknu iz ovih Uslova ili su u vezi sa njima prvo pokušati
            da reše arbitražom u skladu sa pravilima{" "}
            <strong>Arbitražnog suda Privredne komore Srbije</strong>. Arbitraža
            će se održavati u Beogradu, na srpskom jeziku. Arbitražna odluka
            biće konačna i obavezujuća za obe strane. Ako korisnik nije saglasan
            sa arbitražom, on može da odbije ovu opciju, te će spor biti rešen
            sudskim putem kako je opisano ispod.
          </li>
          <li>
            <strong>Sudsko rešavanje:</strong> U slučaju da strane ne postignu
            dogovor putem arbitraže ili ako arbitraža nije prihvaćena od strane
            korisnika, spor će biti rešen pred nadležnim sudom Republike Srbije.
            Nadležan sud biće sud u mestu sedišta Kompanije{" "}
            <strong>PR Nutritivna Transformacija</strong>, osim ukoliko važeći
            zakoni Republike Srbije ne nalažu drugačije.
          </li>
        </ol>

        <h2
          id="sporoviPodnaslov2"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Izuzeci za potrošače
        </h2>

        <p className="mb-4">
          U skladu sa Zakonom o zaštiti potrošača, potrošači imaju pravo da
          pokrenu postupak pred nadležnim sudom bez obaveze pristupanja
          arbitraži, ukoliko to odluče. Pored toga, potrošači mogu podneti
          prigovor Komisiji za zaštitu potrošača u skladu sa važećim zakonom.
        </p>

        <h2
          id="sporoviPodnaslov3"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Pravo na podnošenje pritužbi
        </h2>

        <p className="mb-4">
          Korisnici imaju pravo da podnesu pritužbu ili zahtev za rešavanje
          sporova Kompaniji putem email adrese{" "}
          <a
            href="mailto:office@nutritrans.com"
            className="text-blue-300 hover:text-blue-500"
          >
            office@nutritrans.com
          </a>{" "}
          . Kompanija će uložiti razumne napore da odgovori na pritužbu
          korisnika u roku od 30 dana od dana prijema
        </p>

        <p className="mb-4">
          Korisnici takođe imaju pravo da podnesu žalbu nadležnim organima
          Republike Srbije, uključujući{" "}
          <strong>Ministarstvo trgovine, turizma i telekomunikacija</strong> ili{" "}
          <strong>Poverenika za zaštitu podataka o ličnosti</strong>, u skladu
          sa zakonima Republike Srbije.
        </p>

        <h2 id="izmene" className="text-md font-semibold text-gray-900 mb-4">
          9. Izmene i Ažuriranje Uslova
        </h2>
        <p className="mb-4">
          Ova sekcija reguliše način na koji Kompanija može menjati i ažurirati
          ove Uslove korišćenja, kao i kako će korisnici biti obavešteni o
          takvim izmenama.
        </p>

        <h2
          id="izmenePodnaslov"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Pravo na izmene
        </h2>

        <p className="mb-4">
          Kompanija NutriTrans zadržava pravo da u bilo kom trenutku, prema
          sopstvenom nahođenju, izmeni ili ažurira ove Uslove korišćenja, u
          skladu sa važećim zakonima Republike Srbije, uključujući Zakon o
          zaštiti potrošača i Zakon o obligacionim odnosima.
        </p>

        <p className="mb-4">
          Izmene Uslova mogu biti posledica promena u zakonodavstvu, tehničkih
          unapređenja aplikacije, ili promene u poslovanju Kompanije, a sve u
          cilju poboljšanja korisničkog iskustva i pravne usklađenosti.
        </p>

        <h2
          id="izmenePodnaslov1"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Obaveštenje o izmenama
        </h2>

        <p className="mb-4">
          U slučaju bilo kakvih izmena ovih Uslova, Kompanija će blagovremeno
          obavestiti korisnike na jedan ili više sledećih načina:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Putem emaila:</strong> Korisnici će primiti obaveštenje o
            izmenama na email adresu koja je registrovana prilikom kreiranja
            naloga.
          </li>
          <li>
            <strong>Notifikacija u aplikaciji:</strong> Korisnici će biti
            obavešteni o izmenama putem notifikacije u aplikaciji prilikom
            sledećeg pristupa aplikaciji.
          </li>
          <li>
            <strong>Obaveštenje na sajtu:</strong> Kompanija može postaviti
            obaveštenje o izmenama Uslova na zvaničnom sajtu aplikacije.
          </li>
        </ul>

        <p className="mb-4">
          Obaveštenje će sadržati kratak opis izmena, datum stupanja na snagu i
          uputstvo kako korisnici mogu prihvatiti ili odbiti izmene, kao i sve
          relevantne informacije o uticaju izmena na prava i obaveze korisnika.
        </p>

        <h2
          id="izmenePodnaslov2"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Datum stupanja na snagu
        </h2>

        <p className="mb-4">
          Izmene Uslova korišćenja stupaju na snagu <strong>7 dana</strong>{" "}
          nakon obaveštenja korisnika, osim ukoliko zakon ne nalaže drugačiji
          rok ili izmenjeni Uslovi ne predviđaju duži rok za stupanje na snagu.
        </p>

        <p className="mb-4">
          Ukoliko korisnik ne prihvati izmene, ima pravo da prestane da koristi
          aplikaciju i otkaže svoj nalog pre nego što izmene stupe na snagu.
          Nastavak korišćenja aplikacije nakon stupanja izmena na snagu smatraće
          se prihvatanjem novih Uslova korišćenja.
        </p>

        <h2
          id="izmenePodnaslov3"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Obaveza pregleda izmena
        </h2>

        <p className="mb-4">
          Korisnici su odgovorni da periodično pregledaju Uslove korišćenja kako
          bi bili informisani o potencijalnim izmenama, čak i ako nisu primili
          pojedinačno obaveštenje putem emaila ili aplikacije. Kompanija ne
          snosi odgovornost za nepoznavanje izmena Uslova od strane korisnika,
          ukoliko su izmene objavljene na odgovarajući način.
        </p>

        <h2
          id="izmenePodnaslov5"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Kontakt
        </h2>

        <p className="mb-4">
          Za sve dodatne informacije u vezi sa izmenama Uslova, korisnici mogu
          kontaktirati Kompaniju putem email adrese{" "}
          <a
            href="mailto:office@nutritrans.com"
            className="text-blue-300 hover:text-blue-500"
          >
            office@nutritrans.com
          </a>{" "}
          .
        </p>

        <h2 id="kontakt" className="text-md font-semibold text-gray-900 mb-4">
          10. Kontakt Informacije
        </h2>
        <p className="mb-4">
          Korisnicima NutriTrans aplikacije pružamo podršku i omogućavamo
          komunikaciju sa našim timom za pitanja, sugestije, pritužbe i tehničku
          podršku. Naš cilj je da obezbedimo efikasnu i pravovremenu
          komunikaciju kako bismo rešili sve nedoumice ili probleme sa kojima se
          korisnici mogu susresti prilikom korišćenja aplikacije.
        </p>

        <h2
          id="kontaktPodnaslov"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Podrška korisnicima
        </h2>

        <p className="mb-4">
          Korisnici mogu kontaktirati naš tim za podršku na sledeće načine:
        </p>

        <ul className="list-disc pl-6 space-y-2 mb-4">
          <li>
            <strong>Email podrška:</strong> Korisnici mogu poslati pitanja,
            pritužbe ili zahteve putem email adrese: <strong>NutriTrans</strong>
            . Naša korisnička podrška odgovara na email poruke u roku od{" "}
            <strong>48 sati</strong> radnim danima.
          </li>
          <li>
            <strong>Notifikacija u aplikaciji:</strong> Korisnici će biti
            obavešteni o izmenama putem notifikacije u aplikaciji prilikom
            sledećeg pristupa aplikaciji.
          </li>
          <li>
            <strong>Obaveštenje na sajtu:</strong> Kompanija može postaviti
            obaveštenje o izmenama Uslova na zvaničnom sajtu aplikacije.
          </li>
        </ul>

        <h2
          id="kontaktPodnaslov"
          className="text-xl font-semibold text-gray-900 mb-4"
        >
          Podnošenje pritužbi
        </h2>

        <p className="mb-4">
          Ukoliko korisnici imaju pritužbe u vezi sa kvalitetom usluga ili bilo
          kojim aspektom korišćenja aplikacije, mogu podneti formalnu pritužbu
          putem email adrese{" "}
          <a
            href="mailto:office@nutritrans.com"
            className="text-blue-300 hover:text-blue-500"
          >
            office@nutritrans.com
          </a>{" "}
          . Sve pritužbe će biti pažljivo razmotrene, a korisnici će dobiti
          odgovor u roku od <strong>30 dana</strong> od dana prijema pritužbe, u
          skladu sa Zakonom o zaštiti potrošača.
        </p>

        <p className="mb-4">
          Korisnici takođe imaju pravo da podnesu pritužbu nadležnim organima
          Republike Srbije, uključujući Ministarstvo trgovine, turizma i
          telekomunikacija ili Poverenika za zaštitu podataka o ličnosti, u
          skladu sa zakonima koji regulišu zaštitu potrošača i zaštitu podataka
          o ličnosti.
        </p>

        {/* work here */}
      </div>
    </div>
  );
};

export default TermAndConditions;

// function TermAndConditions() {
//   return (
//     <>
//       <div className="max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg my-6">
//         {/* Naslov */}
//         <h1 className="text-3xl font-bold text-center text-gray-800 mb-6">
//           Politika privatnosti, reklamacije i uslovi korišćenja
//         </h1>

//         {/* Politika privatnosti */}
//         <section className="mb-6">
//           <h2 className="text-2xl font-semibold text-gray-800 flex items-center mb-4">
//             <LockClosedIcon className="w-6 h-6 text-gray-500 mr-3" />
//             Politika privatnosti
//           </h2>
//           <p className="text-gray-700 text-lg leading-relaxed">
//             U ime Nutri Trans obavezujemo se da ćemo čuvati privatnost svih
//             naših kupaca. Prikupljamo samo neophodne, osnovne podatke o kupcima/
//             korisnicima i podatke neophodne za poslovanje i informisanje
//             korisnika u skladu sa dobrim poslovnim običajima i u cilju pružanja
//             kvalitetne usluge. Dajemo kupcima mogućnost izbora uključujući
//             mogućnost odluke da li žele ili ne da se izbrišu sa mailing lista
//             koje se koriste za marketinške kampanje. Svi podaci o
//             korisnicima/kupcima se strogo čuvaju i dostupni su samo zaposlenima
//             kojima su ti podaci nužni za obavljanje posla. Svi zaposleni Nutri
//             Trans (i poslovni partneri) odgovorni su za poštovanje načela
//             zaštite privatnosti.
//           </p>
//         </section>

//         {/* Uslovi korišćenja */}
//         <section className="mb-6">
//           <h2 className="text-2xl font-semibold text-gray-800 flex items-center mb-4">
//             <ExclamationCircleIcon className="w-6 h-6 text-yellow-500 mr-3" />
//             Uslovi korišćenja
//           </h2>
//           <p className="text-gray-700 text-lg leading-relaxed">
//             Upotrebom ovog internet sajta potvrđujete da ste pročitali, razumeli
//             i prihvatili ove uslove korišćenja (u daljem tekstu “uslovi”) i
//             slažete se da ste obavezni da ih poštujete, kao i sve druge
//             primenljive zakone i propise. Ukoliko ne prihvatate ove uslove,
//             nemojte koristiti ovaj internet sajt.
//             <br />
//             <br />
//             Nutri Trans može izmeniti ove Uslove u bilo kom trenutku izmenama u
//             ovom tekstu. Trebalo bi da posetite ovu stranicu s vremena na vreme
//             i proverite ažurne Uslove, jer ste njima zakonski vezani. Pojedine
//             odredbe ovih Uslova mogu biti nadjačane eksplicitnim zakonskim
//             aktima ili saopštenjima istaknutim na drugim stranicama ovog sajta.
//           </p>
//         </section>

//         {/* Zaštita poverljivih podataka */}
//         <section className="mb-6">
//           <h2 className="text-2xl font-semibold text-gray-800 flex items-center mb-4">
//             <LockClosedIcon className="w-6 h-6 text-gray-500 mr-3" />
//             Zaštita poverljivih podataka o transakciji
//           </h2>
//           <p className="text-gray-700 text-lg leading-relaxed">
//             Prilikom unošenja podataka o platnoj kartici, poverljive informacija
//             se prenose putem javne mreže u zaštićenoj (kriptovanoj) formi
//             upotrebom SSL protokola i PKI sistema, kao trenutno najsavremenije
//             kriptografske tehnologije.
//             <br />
//             <br />
//             Sigurnost podataka prilikom kupovine, garantuje procesor platnih
//             kartica, Banca Intesa ad Beograd, pa se tako kompletni proces
//             naplate obavlja na stranicama banke. Niti jednog trenutka podaci o
//             platnoj kartici nisu dostupni našem sistemu.
//           </p>
//         </section>

//         {/* Povraćaj sredstava */}
//         <section className="mb-6">
//           <h2 className="text-2xl font-semibold text-gray-800 flex items-center mb-4">
//             <CreditCardIcon className="w-6 h-6 text-green-500 mr-3" />
//             Povraćaj sredstava
//           </h2>
//           <p className="text-gray-700 text-lg leading-relaxed">
//             U slučaju vraćanja robe i povraćaja sredstava kupcu koji je
//             prethodno platio nekom od platnih kartica, delimično ili u celosti,
//             a bez obzira na razlog vraćanja, Nutri Trans je u obavezi da
//             povraćaj vrši isključivo preko VISA, EC/MC i Maestro metoda
//             plaćanja, što znači da će banka na zahtev prodavca obaviti povraćaj
//             sredstava na račun korisnika kartice.
//           </p>
//         </section>

//         {/* Upotreba internet sajta */}
//         <section className="mb-6">
//           <h2 className="text-2xl font-semibold text-gray-800 flex items-center mb-4">
//             <DocumentTextIcon className="w-6 h-6 text-indigo-500 mr-3" />
//             Upotreba internet sajta
//           </h2>
//           <p className="text-gray-700 text-lg leading-relaxed">
//             Sav materijal na ovom internet sajtu (u daljem tekstu “Sajt”) je
//             zaštićen autorskim pravima i svaka neovlašćena upotreba može
//             predstavljati kršenje Zakona o autorskom i srodnim pravima, Zakona o
//             žigovima ili drugih zakona iz oblasti intelektualne svojine. Osim
//             ukoliko je drugačije naznačeno na drugom mestu na ovom sajtu, sav
//             sadržaj možete pregledati, kopirati, štampati ili preuzimati
//             isključivo za ličnu, nekomercijalnu upotrebu i u informativne svrhe,
//             pod uslovom da sve naznake o autorskim pravima ili drugim vlasničkim
//             informacijama koji su sadržani u originalnom dokumentu zadržite u
//             svim kopijama.
//             <br />
//             <br />
//             Ne možete menjati sadržaj ovog sajta ni na koji način, niti ga
//             reprodukovati ili javno prikazivati, izvoditi, distribuirati ili na
//             drugi način koristiti u javne ili komercijalne svrhe.
//           </p>
//         </section>

//         {/* Informacije */}
//         <section className="mb-6">
//           <h2 className="text-2xl font-semibold text-gray-800 flex items-center mb-4">
//             <InformationCircleIcon className="w-6 h-6 text-blue-500 mr-3" />
//             Informacije
//           </h2>
//           <p className="text-gray-700 text-lg leading-relaxed">
//             Svi materijali, povratne informacije ili druge vrste informacija
//             koje dostavite ovom Sajtu ili u kompaniji Nutri Trans povodom ovog
//             sajta (“Informacije”) neće biti smatrani za poverljive ili
//             vlasničke. Nutri Trans će biti isključivi vlasnik svih informacija
//             prikupljenih na Sajtu ili u vezi sa njim. Nutri Trans nema nikakve
//             obaveze u odnosu na takve informacije i slobodan je da ih koristi
//             bez ograničenja za bilo koje svrhe (kao što je upotreba,
//             reprodukcija, modifikacija, objavljivanje, (re)distribucija, javno
//             prikazivanje itd.) i bez navođenja izvora.
//           </p>
//         </section>

//         {/* Reklamacije */}
//         <section className="mb-6">
//           <h2 className="text-2xl font-semibold text-gray-800 flex items-center mb-4">
//             <ExclamationCircleIcon className="w-6 h-6 text-red-500 mr-3" />
//             Reklamacije
//           </h2>
//           <p className="text-gray-700 text-lg leading-relaxed">
//             <strong>Reklamacije na oštećenje u transportu:</strong> Veoma je
//             važno da sva oštećenja u transportu, vidljiva na pakovanju proizvoda
//             odmah prijavite na office@nutritrans.com. Svako oštećenje pri
//             transportu kupac je dužan da prijavi u roku od 24h od prijema robe.
//             <br />
//             <br />
//             Ukoliko uočite takvo oštećenje, nemojte potpisati prijem pošiljke
//             ili zamolite kurira da sačeka dok proverite da li oštećenje na
//             pakovanju uslovilo i oštećenje samog proizvoda ili gubitak delova.
//             Ukoliko proizvod nije oštećen, i svi delovi su na broju, potpišite
//             prijem pošiljke.
//           </p>
//         </section>

//         {/* Izjava o konverziji */}
//         <section className="mb-6">
//           <h2 className="text-2xl font-semibold text-gray-800 flex items-center mb-4">
//             <InformationCircleIcon className="w-6 h-6 text-blue-500 mr-3" />
//             Izjava o konverziji
//           </h2>
//           <p className="text-gray-700 text-lg leading-relaxed">
//             Sva plaćanja će se vršiti u srpskoj valuti – dinarima (RSD). Iznos
//             za koji će račun vaše kreditne kartice biti zadužen dobija se
//             konverzijom cene u evrima u srpski dinar prema zvaničnom kursu
//             Narodne banke Srbije. Prilikom zaduživanja vaše kreditne kartice,
//             isti iznos se konvertuje u lokalnu valutu prema kursu udruženja
//             kreditnih kartica. Kao rezultat ove konverzije postoji mogućnost
//             blage razlike od originalne cene navedene na našem sajtu.
//             <br />
//             <br />
//             Sve cene su izražene sa PDV-om i nema dodatnih troškova.
//           </p>
//         </section>
//       </div>
//       <br />
//       <br />
//       <br />
//       <br />
//       {/* <br />
//       <br /> */}
//     </>
//   );
// }

// export default TermAndConditions;
